export default __webpack_public_path__ + "static/media/home_product_img2_HK.81ab92a2.webp";